<template>
    <div class="nav-rich-wrap" id="menu-navires">
        <div class="fx-wrap">
            <div class="one-boat">
                <div>
                    <img :src=items.briseGlaceImgUrl alt="" class="briseGlace">
                </div>
                <p>Brise-Glaces</p>
                <ul>
                    <li v-for="(item, index) in items.briseGlace">
                        <a :href=item.url>{{item.name}}</a>
                    </li>
                </ul>
            </div>


            <div class="one-boat">
                <div>
                    <img :src=items.bateauPolaireImgUrl alt="" class="bateauPolaire">
                </div>
                <p>Navires polaires</p>
                <ul>
                    <li v-for="(item, index) in items.bateauPolaire">
                        <a :href=item.url>{{item.name}}</a>
                    </li>
                </ul>
            </div>


            <div class="one-boat">
                <div>
                    <img :src=items.yachtImgUrl alt="" class="yacht">
                </div>
                <p>Yachts</p>
                <ul>
                    <li v-for="(item, index) in items.yacht">
                        <a :href=item.url>{{item.name}}</a>
                    </li>
                </ul>
            </div>


            <div class="one-boat">
                <div>
                    <img :src=items.yachtPolaireImgUrl alt="" class="yachtPolaire">
                </div>
                <p>Yachts polaires</p>
                <ul>
                    <li v-for="(item, index) in items.yachtPolaire">
                        <a :href=item.url>{{item.name}}</a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>


    export default {
        props: {
            items: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {};
        },
        methods: {},
        created() {
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/menus/RichMenuNavires.vue